// stores/useUserStore.js
import { defineStore } from 'pinia';
 
export const useMobileStore = defineStore('mobile', {
  state: () => ({
    // 这里存储你的状态
    // username: 'John Doe',
    // age: 30,
    isMobile:false
  }),
  actions: {
    // 你可以在这里定义你的 actions，例如更新用户名或年龄
    updateMobile(isMobile) {
        this.isMobile = isMobile;
      },
  },
});